// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__JlELC","footerList":"Footer_footerList__4GkpS","footerListContent":"Footer_footerListContent__uniI+","listContentItem":"Footer_listContentItem__VghHD"};